import { ReactElement, RefObject, useState } from 'react'
import { Translate2 } from 'common'
import { breakpoints } from '../../theme/breakpoints'
import { Hyperlink } from './Hyperlink'
import styled from 'styled-components'
import { Print as PrintIcon } from '@mui/icons-material'
import { useReactToPrint } from 'react-to-print'
import { Button } from '../forms/Button'
import { ContentNode } from 'react-to-print/lib/types/ContentNode'
import { Spinner } from 'react-bootstrap'

interface PrintInterface {
  beforePrint?: () => Promise<void>
  afterPrint?: () => void
  printRef: RefObject<ContentNode> | null
  documentTitle: string
  displayText: string
  underlined?: boolean
  printButton?: boolean
  pageStyle?: string
}

export const Print = (props: PrintInterface): ReactElement | null => {
  const {
    beforePrint,
    afterPrint,
    printRef,
    documentTitle,
    displayText,
    underlined,
    printButton,
    pageStyle,
  } = props

  const [isPrinting, setIsPrinting] = useState(false)

  const handlePrint = useReactToPrint({
    onBeforePrint: async () => {
      setIsPrinting(true)
      await beforePrint?.()
    },
    onAfterPrint: () => {
      setIsPrinting(false)
      afterPrint?.()
    },
    contentRef: printRef,
    documentTitle,
    pageStyle,
  })

  if (!window.print) {
    return null
  }

  return (
    <>
      {!printButton && (
        <Hyperlink action={() => handlePrint()} underlined={!!underlined}>
          <Flex>
            <PrintIcon style={{ marginRight: 5, width: 18 }} />
            <PrintInstruction>
              <span>{Translate2(displayText)}</span>
            </PrintInstruction>
            {isPrinting && <StyledSpinner animation="border" size="sm" />}
          </Flex>
        </Hyperlink>
      )}
      {printButton && (
        <Button text={Translate2('print')} onClick={handlePrint} />
      )}
    </>
  )
}

const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

const StyledSpinner = styled(Spinner)`
  width: 16px;
  height: 16px;
  border-width: 2px;
`

const PrintInstruction = styled.div`
  font-size: 16px;
  text-transform: lowercase;
  &:first-letter {
    text-transform: uppercase;
  }

  @media screen and (max-width: ${breakpoints.tablet}px) {
    font-size: 14px;
  }
`
